/**
 * Модальне вікно поверх УСЬОГО застосунку (ч.1222).
 *
 * `position: fixed` + великий `z-index` не допомагають, якщо вікно змонтоване всередині
 * елемента, що утворює власний шар: права колонка документа — `position: sticky`
 * (`.doclayout__rail`), а це окремий контекст накладання. Вікно лишалось у шарі колонки, і
 * верхнє меню (`.app__topnav`, z-index 30) малювалось ПОВЕРХ нього — верх високого вікна
 * ховався під меню (зауваження власника до вікна привʼязки документів).
 * Портал у `body` виносить вікно на рівень сторінки. Події React і далі спливають деревом
 * компонентів, тож `stopPropagation` у вікні працює як раніше.
 */
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export default function BodyPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
